export default __webpack_public_path__ + "static/archia-97b7f9e05b914efa588963c8cbd49f08.woff";